export const faqs = [
  {
    question: "Wie lange dauert das Programm?",
    answer:
      "Das Programm ist auf ein halbes Jahr angelegt. In dieser Zeit schreibst Du Dein Buch und überarbeitest es, sodass Du am Ende ein fertiges Manuskript in den Händen hältst.",
  },
  {
    question: "Brauche ich Talent oder Vorkenntnisse, um ein Buch zu schreiben?",
    answer:
      "Talent macht nur etwa 10 bis 20 Prozent aus, das Handwerkszeug noch einmal so viel. Der Rest ist Disziplin, Dranbleiben und Mindset, und das kann man lernen. Wer den echten Wunsch hat, Schriftstellerin oder Schriftsteller zu werden, kann es auch werden.",
  },
  {
    question: "Was ist die FlowKus-Methode?",
    answer:
      "Die FlowKus-Methode verbindet Flow und Fokus. Du bleibst so mit Deiner Geschichte verbunden, dass Du sie jederzeit abrufen kannst, und lässt Dich nicht ablenken. Am Schreibtisch schreibst Du dann nur noch auf, was ohnehin längst in Deinem Kopf passiert ist.",
  },
  {
    question: "Schaffe ich das neben Beruf und Familie?",
    answer:
      "Ja. Es klingt zunächst widersprüchlich, aber die Methode zielt genau darauf ab, mehr Leichtigkeit in Deinen Alltag zu bringen, obwohl Du zusätzlich ein Buch schreibst. Du lernst, wie Du dranbleibst, auch wenn das Leben voll ist. Ich weiß, wovon ich spreche: Als Mutter von fünf Kindern schreibe ich meine Bücher selbst mitten im Familienalltag.",
  },
  {
    question: "Was lerne ich im Programm konkret?",
    answer:
      "Das komplette Handwerkszeug für ein gutes Buch: Spannungsbogen, Figurenaufbau, Plot und Treatment. Dazu ein echtes Schriftsteller-Mindset, zum Beispiel wie Du Schreibblockaden überwindest und auch dann weiterschreibst, wenn es schwierig wird.",
  },
  {
    question: "Hilft mir das Programm, einen Verlag zu finden?",
    answer:
      "Du lernst, wie Du professionell an Verlage herantrittst. Ich nutze meine Netzwerke für Dich. Damit Du Dein Buch in jedem Fall in den Händen hältst, kannst Du es in unserem hauseigenen Verlag, der Edition Goldfunken, veröffentlichen.",
  },
  {
    question: "Für welche Bücher eignet sich das Coaching?",
    answer:
      "Ob Roman, historischer Roman, Sachbuch, Ratgeber oder Deine eigene Lebensgeschichte: Ich begleite Dich persönlich von der ersten Idee bis zum fertigen Manuskript, damit Du endlich das Buch schreiben kannst, das schon lange in Dir schlummert.",
  },
  {
    question: "Wie kann ich starten?",
    answer:
      "Tritt unserer kostenlosen Facebook-Gruppe „Goldfunken – Von der Idee zum Buch“ bei und lerne die FlowKus-Methode in wöchentlichen Live-Sessions kennen. Oder buche direkt ein kostenloses, unverbindliches Gespräch.",
  },
];
